<ion-card
  [class.on-track]="
    overviewData.targetState === targetRef.onTrack &&
    overviewData?.rangeAndDataReady
  "
  [class.below-track]="
    overviewData.targetState === targetRef.belowTarget &&
    overviewData?.rangeAndDataReady
  "
  [class.above-track]="
    overviewData.targetState === targetRef.aboveTarget &&
    overviewData?.rangeAndDataReady
  "
>
  <ng-container
    *ngIf="!!overviewData?.rangeAndDataReady; else noData"
    [ngTemplateOutlet]="dataPresent"
  >
    <div
      class="content-container"
      [class.desktop]="platform === platformRef.desktop"
      [class.tablet]="platform === platformRef.tablet"
      [class.mobile]="platform === platformRef.mobile"
    >
      <ion-row>
        <ion-col
          class="trend-and-revenue"
          [class.desktop]="platform === platformRef.desktop"
        >
          <p>
            {{ 'i18n.inventory.foodCost.overviewTile.costTrends' | translate }}
          </p>
          <p>
            {{ 'i18n.inventory.foodCost.overviewTile.revenue' | translate }}
          </p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="last-two-reports"
          [class.touch]="platform !== platformRef.desktop"
        >
          <div>
            <p>{{ overviewData.startValue }}%</p>
            <P>{{ overviewData.startDate }}</P>
          </div>
          <ion-icon name="arrow-forward-outline"> </ion-icon>
          <div>
            <p>{{ overviewData.endValue }}%</p>
            <p>{{ overviewData.endDate }}</p>
          </div>
          <app-food-cost-target
            class="food-cost-target"
            data-cy="food-cost-target-component"
            [foodCostTarget]="overviewData?.targetState"
            *ngIf="platform === platformRef.mobile"
          ></app-food-cost-target>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="platform !== platformRef.mobile">
        <ion-col class="target-container">
          <app-food-cost-target
            data-cy="food-cost-target-component"
            [foodCostTarget]="overviewData?.targetState"
          ></app-food-cost-target>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="percentage-message"
          [class.touch]="platform !== platformRef.desktop"
        >
          <p>
            {{
              'i18n.inventory.foodCost.overviewTile.keepPercentage'
                | translate: overviewData.foodCostRange
            }}
          </p>
        </ion-col>
      </ion-row>
    </div>
  </ng-container>
</ion-card>

<ng-template #noData>
  <p class="center-title">
    {{
      (overviewData?.reportsReady
        ? 'i18n.inventory.foodCost.tileOverviewPlaceholderRange'
        : 'i18n.inventory.foodCost.tileOverviewPlaceholder'
      ) | translate
    }}
  </p>
</ng-template>

<ng-template #dataPresent> </ng-template>
